// dna_frontend/src/pages/AdminCheckDuplicates.js
// (*** ĐÃ CẬP NHẬT: HIỂN THỊ 2 DANH SÁCH RIÊNG ***)

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './LietSiManagement.css'; 

const AdminCheckDuplicates = () => {
    const [sameXa, setSameXa] = useState([]);
    const [diffXa, setDiffXa] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchDuplicates = async () => {
        setLoading(true);
        try {
            const res = await api.get('/than-nhan/admin/duplicates');
            // Backend trả về: { sameXa: [], diffXa: [] }
            setSameXa(res.data.sameXa);
            setDiffXa(res.data.diffXa);
        } catch (err) {
            alert('Lỗi tải dữ liệu');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchDuplicates(); }, []);

    const handleDelete = async (id) => {
        if (!window.confirm('Bạn có chắc muốn XÓA VĨNH VIỄN thân nhân này?')) return;
        try {
            // Dùng hàm xóa cứng adminSoftDeleteThanNhan (bạn có thể đổi sang hàm xóa cứng thật nếu muốn)
            await api.delete(`/than-nhan/admin/delete/${id}`); 
            fetchDuplicates(); 
        } catch (err) { alert('Lỗi khi xóa'); }
    };

    const DuplicateTable = ({ groups, title, colorClass }) => (
        <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: colorClass }}>{title} ({groups.length} nhóm)</h2>
            {groups.length === 0 ? <p>Không có dữ liệu.</p> : (
                <div>
                    {groups.map((group, index) => (
                        <div key={index} style={{marginBottom: '20px', border: '1px solid #ccc', borderRadius: '8px', overflow: 'hidden'}}>
                            <div style={{background: '#f0f0f0', padding: '10px', fontWeight: 'bold', borderBottom: '1px solid #ccc'}}>
                                Nhóm {index + 1}: {group.key} ({group.items.length} bản ghi)
                            </div>
                            <table className="crud-table" style={{marginTop: 0}}>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Họ tên</th>
                                        <th>Địa chỉ</th>
                                        <th>Xã</th>
                                        <th>Người tạo</th>
                                        <th>Trạng thái Thu mẫu</th>
                                        <th>Hành động</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {group.items.map(tn => (
                                        <tr key={tn.id}>
                                            <td>{tn.id}</td>
                                            <td>{tn.ho_ten}</td>
                                            <td>{tn.dia_chi}</td>
                                            <td>{tn.ten_xa}</td>
                                            <td>{tn.nguoi_tao || 'Admin/Upload'}</td>
                                            <td style={{
                                                color: tn.trang_thai_thu_mau === 'da_thu_mau' ? 'green' : 'red',
                                                fontWeight: 'bold'
                                            }}>
                                                {tn.trang_thai_thu_mau === 'da_thu_mau' ? 'Đã thu' : 'Chưa thu'}
                                            </td>
                                            <td>
                                                <button className="btn-delete" onClick={() => handleDelete(tn.id)}>Xóa</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    if (loading) return <div className="liet-si-container"><p>Đang quét trùng lặp...</p></div>;

    return (
        <div className="liet-si-container">
            <h1>Kiểm tra Thân nhân Trùng lặp (Key: Tên + Năm sinh + 3 số CCCD)</h1>
            <button onClick={fetchDuplicates} className="btn-primary" style={{marginBottom: '20px'}}>Quét lại</button>
            
            <DuplicateTable groups={sameXa} title="1. Trùng trong CÙNG XÃ (Nghiêm trọng)" colorClass="red" />
            <hr />
            <DuplicateTable groups={diffXa} title="2. Trùng KHÁC XÃ (Cần kiểm tra)" colorClass="orange" />
        </div>
    );
};

export default AdminCheckDuplicates;